import { request } from '@/shared/api/request'
export const getRequestAdjustmentDetail = (id) => {
	return request({ url: `contract/labor/getRequestsAdjustmentDataDetail?reqAdjId=${id}`, method: 'GET' })
}
